module.exports = __webpack_public_path__ + "img/arrow-highlight.63404575.svg";